import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import ErrorPage from './ErrorPage';
import MainCardContainer from './../MainCardContainer';
import * as actions from './../../data/login/actions';
import { useLanguage } from '../../context/LanguageContext';

const SessionExpired = props => {
  const { labels } = useLanguage();
  const errorPages = labels.errorPages || {};
  const SUBTITLE = (errorPages.sessionExpired?.SUBTITLE || '').split('\n').map(item => (
    <div key={Math.random()}>{item}</div>
  ));

  const handleAction = () => {
    props.redirect('/login');
  };

  return (
    <MainCardContainer
      headTitle=''
      content={[
        <ErrorPage
          title={errorPages.sessionExpired?.TITLE}
          subtitle={SUBTITLE}
          icon={errorPages.sessionExpired?.ICON}
          key={0}
          action={
            <RaisedButton
              label={errorPages.sessionExpired?.ACTION_BTN}
              onClick={handleAction}
              className='action-btn'
            />
          }
        />
      ]}
      isHeaderLayout
    />
  );
};

SessionExpired.propTypes = {
  redirect: PropTypes.func.isRequired
};

SessionExpired.defaultProps = {
  redirect: () => {}
};

const mapDispatchToProps = dispatch => ({
  redirect: path => dispatch(actions.default.redirect(path))
});

export default connect(null, mapDispatchToProps)(SessionExpired);
